import Model  from 'alto-orm/lib/orm/model';

export default class Course extends Model {
  // attrs: name (string), displayName (string), orderNumber (positive smallint),
  //        group (string fkey), isAdditional (bool)

  static primaryKey      = 'name';
  static nominativeName  = 'chod';
  static accusativeName  = 'chod';
  static attrNameMapping = { groupName: 'group' };
};
